import $ from 'jquery';

const minBreakPoint = 450;

class Card {

    constructor (card) {
        this.$card = $(card);

        this.sizeCheck();
        this.events();
    }

    events () {
        var self = this;
        $(window).resize(function() {
            self.sizeCheck();
        });
    }

    sizeCheck () {
        if (this.$card.width() < minBreakPoint) {
            this.$card.addClass('pi-card-horizontal-small');
        } else {
            this.$card.removeClass('pi-card-horizontal-small');
        }
    }
}

const init = () => {
    console.log('card init');
    for(const card of $('.pi-card-horizontal')) {
        new Card(card);
    }
};

export default {
    init
};



// WEBPACK FOOTER //
// ./src/scripts/blocks/card-horizontal.js